import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import HomeIcon from '../../../assets/icons/secondary/Home.svg';
import WorkIcon from '../../../assets/icons/secondary/Work.svg';
import {getAlphaColor, getColor, ms, msi, square} from '../../../styles';
import {Text} from '../../../uikit/Text';
import {View} from '../../../uikit/View';
import {platform} from '../../../utils/platform';

type EnvProp = Pick<StyledProps, 'env'>;

const SText = styled(Text).attrs({weight: 'semibold'})<
  EnvProp & {
    buttonVariant?: StyledProps['variant'];
  }
>`
  margin-inline-end: ${ms(6)};
  color: ${p => getColor(p.env)(p)};

  ${p =>
    p.buttonVariant === 'circle' &&
    css`
      width: 0;
      height: 0;
      opacity: 0;
      margin-inline-end: 0;
    `}
`;

export {SText as Text};

export const IconContainer = styled(View)`
  position: relative;
`;

export const Icon = styled(props => {
  const EnvIcon = props.env === 'b2b' ? WorkIcon : HomeIcon;

  return <EnvIcon {...props} />;
}).attrs(p => ({
  fill: getColor(p.env)(p),
}))<EnvProp>`
  ${square(20)};
`;

export const UpdatesBadge = styled(View)<EnvProp>`
  position: absolute;
  inset-block-start: ${p => (p.env === 'core' ? msi(1) : msi(2))}px;
  inset-inline-end: ${p => (p.env === 'core' ? msi(2) : 0)}px;
  ${square(6)};
  border-radius: ${ms(3)};
  background-color: ${getColor('error')};
`;

export const Container = styled(View)<StyledProps>`
  height: ${ms(40)};
  border-radius: ${ms(20)};
  justify-content: center;
  align-items: center;
  padding-inline: ${ms(16)} ${ms(16)};
  background-color: ${p => getAlphaColor(p.env, 0.2)};
  transition: background-color 0.2s ease-in-out;

  ${p =>
    p.variant === 'circle' &&
    css`
      width: ${ms(40)};
    `}

  ${platform.isWeb &&
  css<StyledProps>`
    &:hover {
      background-color: ${p => getColor(p.env)(p)};

      ${SText} {
        color: ${p => getColor('static.white')(p)};
      }

      ${Icon} {
        fill: ${p => getColor('static.white')(p)};
      }
    }
  `}
`;
